var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-steps',{staticClass:"glp-steps",class:[_vm.processCls],attrs:{"active":_vm.active,"align-center":""}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }